<template>
  <div>
    <!----------- [START] TABLE ----------->
    <Table
        :columns="columns"
        :class="tableClass"
        :data="diplayedData"
        :row-class-name="rowClassName"
        :height="height"
        @on-row-click="onRowClick"
        :no-data-text="$t('No data')"
        :loading="loading"
    />
    <Page v-if="dataTable.length > pageSize" :total="dataTable.length" :page-size="pageSize" class="paging" @on-change="changePage"/>
  </div>
</template>

<script>
export default {
    name: "AppTable",
    props: {
        dataTable: {default: null},
        columns: {default: null},
        tableClass: {default: null},
        rowClassName: {default: null},
        height: {default: null},
        loading: {default: false},
    },
    data() {
        return {
            diplayedData: [],
            pageSize: 30,
        }
    },
    watch: {
        dataTable() {
            this.diplayedData = this.dataTable.slice(0, this.pageSize);
        },
    },
    methods: {
        changePage(index) {
            console.log(index)
            var _start = (index - 1) * this.pageSize;
            var _end = index * this.pageSize;
            this.diplayedData = this.dataTable.slice(_start, _end);
        },
        onRowClick(tableRow, tableRowIndex) {
            this.$emit('on-row-click', tableRow, tableRowIndex)
        }
    }
}
</script>

<style>
.paging {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}

.ivu-page-item:hover,
.ivu-page-prev:hover:not(.ivu-page-disabled),
.ivu-page-next:hover:not(.ivu-page-disabled) {
    border-color: var(--secondary-color);
    background-color: rgba(113, 87, 242, 0.1)
}
.ivu-page-item:hover a,
.ivu-page-prev:hover:not(.ivu-page-disabled) a,
.ivu-page-next:hover:not(.ivu-page-disabled) a {
    color: var(--primary-color);
}
.ivu-page-item-active {
    border-color: var(--secondary-color);
}
.ivu-page-item-active a {
    color: var(--primary-color);
}
</style>
